<div class="d-flex flex-column mb-3 inline-vertical-gap-10">
  <p>{{ 'content.choose-a-type-of-device-to-add' | translate }}</p>
  <app-mfa-addable-device [iconTitle]="'content.add-email-icon' | translate"
    [adding]="addingEmail" [description]="'content.mfa-device-descriptions.email' | translate"
    [faIcon]="faAt" [heading]="'content.person.email' | translate"
    (addClicked)="addEmail()">
    @if (_showStartPairingForm) {
      <form
        [formGroup]="startPairingFormGroup"
        [ngClass]="{'form-submitted': startPairingFormSubmitted}"
        (submit)="startOfflinePairing(startPairingFormGroup.value)">
        @if (startPairingFormGroup.controls.email) {
          <div class="form-group">
            <label>{{ 'content.person.email' | translate }} *
              <input class="form-control" type="email" autocomplete="on" formControlName="email" placeholder="email@example.com" #emailInput>
            </label>
            <app-validation-errors [displayErrors]="startPairingFormSubmitted" [errors]="startPairingFormGroup.controls.email.errors" [element]="emailInput"></app-validation-errors>
          </div>
        }
        <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
          <button class="tu-button secondary tu-shadow" type="button" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
          <button class="tu-button primary tu-shadow" type="submit">{{ 'content.submit' | translate }}</button>
        </div>
      </form>
    }
    <ng-container *ngTemplateOutlet='finishPairingForm'></ng-container>
  </app-mfa-addable-device>

  <app-mfa-addable-device [iconTitle]="'content.add-sms-icon' | translate"
    [adding]="addingSms" [description]="'content.mfa-device-descriptions.sms' | translate"
    [faIcon]="faComments" [heading]="'content.sms' | translate"
    (addClicked)="addSms()">
    <ng-container *ngTemplateOutlet='startPairingPhoneForm'></ng-container>
  </app-mfa-addable-device>

  <app-mfa-addable-device [iconTitle]="'content.add-phone-icon' | translate"
    [adding]="addingPhone" [description]="'content.mfa-device-descriptions.voice' | translate"
    [faIcon]="faPhone" [heading]="'content.phone.phone' | translate"
    (addClicked)="addPhone()">
    <ng-container *ngTemplateOutlet='startPairingPhoneForm'></ng-container>
  </app-mfa-addable-device>

  <app-mfa-addable-device [iconTitle]="'content.add-ping-app-icon' | translate"
    [adding]="addingApp" [description]="'content.mfa-device-descriptions.app' | translate"
    [faIcon]="faMobile" [heading]="'content.mfa-ping-app' | translate"
    (addClicked)="addPingApp()">
    <div class="d-flex justify-content-center">
      @if (mfaActivationCode?.qrPayload) {
        <div class="mt-3">
          <div>{{ 'content.mfa-scan-qr-code' | translate }}</div>
          <div>{{ 'content.mfa-enter-activation-code' | translate }}</div>
          <div class="d-flex justify-content-center">
            <div class="flex-column">
              <qrcode
                cssClass=""
                [elementType]="elementType"
                [errorCorrectionLevel]="errorCorrectionLevel"
                [qrdata]="mfaActivationCode.qrPayload">
              </qrcode>
              <div class="activation-code d-flex justify-content-center"><strong>{{ mfaActivationCode.activationCode }}</strong></div>
            </div>
          </div>
          <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
            <button class="tu-button secondary tu-shadow" type="button" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
          </div>
        </div>
      } @else {
        {{ 'content.please-wait' | translate }}
      }
    </div>
  </app-mfa-addable-device>

</div>

<ng-template #finishPairingForm>
  @if (_showFinishPairingForm) {
    <form
      [formGroup]="finishPairingFormGroup"
      [ngClass]="{'form-submitted': finishPairingFormSubmitted}"
      (submit)="finishOfflinePairing(finishPairingFormGroup.value)">
      <div>{{ 'content.sent-code-to-device' | translate:{field: 'content.code' | translate} }}</div>
      <div class="form-group">
        <label>{{ 'content.code' | translate }} *
          <input class="form-control" type="text" autocomplete="off" formControlName="code" #codeInput>
        </label>
        <app-validation-errors [displayErrors]="finishPairingFormSubmitted" [errors]="finishPairingFormGroup.controls.code.errors" [element]="codeInput"></app-validation-errors>
      </div>
      <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
        <button class="tu-button secondary tu-shadow" type="button" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
        <button class="tu-button primary tu-shadow" type="submit">{{ 'content.submit' | translate }}</button>
      </div>
    </form>
  }
</ng-template>

<ng-template #startPairingPhoneForm>
  @if (_showStartPairingForm) {
    <form
      [formGroup]="startPairingFormGroup"
      [ngClass]="{'form-submitted': startPairingFormSubmitted}"
      (submit)="startOfflinePairing(startPairingFormGroup.value)">
      @if (startPairingFormGroup.controls.phone) {
        <app-phone-form-row
        phoneFormControlName="phone" [enablePhoneMask]="enablePhoneMask" [formGroup]="startPairingFormGroup"></app-phone-form-row>
      }
      <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
        <button class="tu-button secondary tu-shadow" type="button" (click)="cancel()">{{ 'content.cancel' | translate }}</button>
        <button class="tu-button primary tu-shadow" type="submit">{{ 'content.submit' | translate }}</button>
      </div>
    </form>
  }
  <ng-container *ngTemplateOutlet='finishPairingForm'></ng-container>
</ng-template>
